import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertaRoutingModule } from './alerta-routing-module';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { MessageModule } from 'primeng/primeng';
import { NgxPaginationModule } from 'ngx-pagination';
import { ShareModule } from 'src/app/share/share.module';
import { AlertaComponent } from './alerta.component';
import { ModalAlertaComponent } from './modal-alerta/modal-alerta.component';

@NgModule({
  declarations: [
  ModalAlertaComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AlertaRoutingModule,
    ReactiveFormsModule,
    MessageModule,
    NgxPaginationModule,
    ShareModule
    
  ],
  providers: [
    AuthGuard,
  ],
  entryComponents: [
    AlertaComponent,
    ModalAlertaComponent
  ]
})
export class AlertaModule { }
